import VariableVariablesSelect from "./variable-variables-select";


const VariableFormItems = {
    VariablesSelect: VariableVariablesSelect,
};

export default VariableFormItems;